module.exports = __webpack_public_path__ + "img/P90X.43729b83.jpeg";